module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av74-1234c56de10d86f4b6d6aa21b5d63250.jpg";